import { Component, ElementRef, Inject, OnInit, QueryList, ViewChild } from '@angular/core';
import { nkServices } from '../../servicios/app.nkservicios.services';
import { AppComponent } from 'src/app/app.component';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { HashKeyServices } from '../../servicios/app.hashkey.services';
import { AppUtilService } from '../../servicios/app.util.service';
import { AtributosService } from '../../servicios/atributos.service';
import { ToastNotificationService } from '../../servicios/toast-notification.service';
import { environment } from 'src/environments/environment';
import { FormRegistroAppComponent } from '../form-registro-app/form-registro-app.component';
import { FormmMsgComponent } from '../formm-msg/formm-msg.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { RxwebValidators } from '@rxweb/reactive-form-validators';
import { FormRecuperacionComponent } from '../form-recuperacion/form-recuperacion.component';
import { SwiperComponent } from "swiper/angular";
// import Swiper core and required modules
import SwiperCore, { Swiper, Virtual } from 'swiper';
import { TemasService } from '../../servicios/temas.service';

// install Swiper modules
SwiperCore.use([Virtual]);
@Component({
  selector: 'app-form-perfil',
  templateUrl: './form-perfil.component.html',
  styleUrls: ['./form-perfil.component.css']
})
export class FormPerfilComponent implements OnInit {
  @ViewChild('swiper_1', { static: false }) swiper_1?: SwiperComponent;
  @ViewChild('swiper_2', { static: false }) swiper_2?: SwiperComponent;
  @ViewChild('swiper_3', { static: false }) swiper_3?: SwiperComponent;
  @ViewChild('swiper_4', { static: false }) swiper_4?: SwiperComponent;
  @ViewChild('swiper_5', { static: false }) swiper_5?: SwiperComponent;
  img:any;
  nombre:any;
  objectURL:any;
  archivo:File;
  forma:FormGroup;
  hide = true;
  cabeza:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  ojo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  boca:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  brazo:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  pie:any = this.atrb.IMAGENES_FIJAS.sin_img_prod;
  val_galeria:any = [];
  val_cabeza:any = [];
  val_ojo:any = [];
  val_boca:any = [];
  val_brazos:any = [];
  val_pies:any = [];
  termino = '1';
  panelOpenState = true;
  checked_0:any;
  checked_1:any;
  checked_2:any;
  checked_3:any;
  checked_4:any;
  constructor(
    private servicio:nkServices,
    private app:AppComponent,
    private fb:FormBuilder,
    private dialog: MatDialog,
    private router:Router,
    private hashkey:HashKeyServices,
    private util:AppUtilService,
    private atrb:AtributosService,
    private notifi:ToastNotificationService,
    private tem:TemasService,
    private dialogRef: MatDialogRef<FormRegistroAppComponent>,
      ///en el injectable llega la informacion del metodo padre en data
      @Inject(MAT_DIALOG_DATA) private data: any){
  console.log(data, 'primero');
  this.forma = fb.group({
          'cod_usuario': [data.data.cod_usuario],
          'des_usuario': [data.data.nombre,[Validators.required]],
          'apellido': [null],
          'edad': [null],
          'fecha_nacimiento': [null],
          'fecha_ingreso': [null],
          'direccion': [null],
          'telefono': [null],
          'nom_usuario': [data.data.nom_usuario,[Validators.required, Validators.pattern(this.atrb.EMAILREGEX)]],
          'correo': [data.data.correo,[Validators.required, Validators.pattern(this.atrb.EMAILREGEX)]],
          /////gerencia
          'cod_unidad':[this.atrb.COD_UNIDAD],
          'des_unidad':[this.atrb.DES_UNIDAD],
          ////dpto
          'cod_dpto':[this.atrb.COD_DPTO],
          'des_dpto':[this.atrb.DES_DPTO],
          ////perfil
          'cod_perfil':[this.atrb.COD_PERFIL_USUARIO],
          'des_perfil':[this.atrb.DES_PERFIL_USUARIO],
          //// rol
          'cod_rol':[this.atrb.USUARIO],
          'des_rol':[this.atrb.DES_USUARIO],
          'mod_usuario': [this.atrb.LICENCIAS.bronce],
          'pass_usuario': [data.data.pass_usuario],
          'archivo':[''],
          'formdata':[''],
          'cod_img':[''],
          'cod_empresa':[''],
          'cod_app':[''],
          'val_objeto':[data.data.val_objeto],
          'val_perfil':[data.data.val_perfil],
          'operacion': [this.atrb.ACCION_ACTUALIZAR],
          'api': [''],
  });
} 

  ngOnInit(){
    this.objectURL  = !localStorage.getItem('mgn')  ? this.atrb.IMAGENES_FIJAS.sin_img_log : this.hashkey.decrypt(localStorage.getItem('mgn')) === '' ? 
                  this.atrb.IMAGENES_FIJAS.sin_img_log : environment.path_storage+this.hashkey.decrypt(localStorage.getItem('mgn'));
    this.nombre  = !localStorage.getItem('nombre') ? '': this.hashkey.decrypt(localStorage.getItem('nombre'));
  }
  ngOnDestroy() {
    URL.revokeObjectURL(this.objectURL);
  }
  slideNext(xvalor:any){
    if (parseInt(xvalor) === 1) {
      this.swiper_1.swiperRef.slideNext(100);
    }
    if (parseInt(xvalor) === 2) {
      this.swiper_2.swiperRef.slideNext(100);
    }
    if (parseInt(xvalor) === 3) {
      this.swiper_3.swiperRef.slideNext(100);
    }
    if (parseInt(xvalor) === 4) {
      this.swiper_4.swiperRef.slideNext(100);
    }
    if (parseInt(xvalor) === 5) {
      this.swiper_5.swiperRef.slideNext(100);
    }
  }
  slidePrev(xvalor:any){
    if (parseInt(xvalor) === 1) {
      this.swiper_1.swiperRef.slidePrev(100);
    }
    if (parseInt(xvalor) === 2) {
      this.swiper_2.swiperRef.slidePrev(100);
    }
    if (parseInt(xvalor) === 3) {
      this.swiper_3.swiperRef.slidePrev(100);
    }
    if (parseInt(xvalor) === 4) {
      this.swiper_4.swiperRef.slidePrev(100);
    }
    if (parseInt(xvalor) === 5) {
      this.swiper_5.swiperRef.slidePrev(100);
    }
  }
 async slideprev_next_cabeza(xvalor:any){
        await this.util.abrirSpinner();
            let valor = this.val_cabeza[ parseInt(xvalor[0].activeIndex)];
            this.cabeza = valor.val_def;
        await this.util.cerrarSpinner();
  }
  async slideprev_next_ojo(xvalor:any){
    await this.util.abrirSpinner();
        let valor = this.val_ojo[ parseInt(xvalor[0].activeIndex)];
        this.ojo = valor.val_def;
    await this.util.cerrarSpinner();
  }
  async  slideprev_next_boca(xvalor:any){
    await this.util.abrirSpinner();
        let valor = this.val_boca[ parseInt(xvalor[0].activeIndex)];
        this.boca = valor.val_def;
    await this.util.cerrarSpinner();
  }
  async slideprev_next_brazo(xvalor:any){
    await this.util.abrirSpinner();
        let valor = this.val_brazos[ parseInt(xvalor[0].activeIndex)];
        this.brazo = valor.val_def;
    await this.util.cerrarSpinner();
  }
  async slideprev_next_pie(xvalor:any){
    await this.util.abrirSpinner();
        let valor = this.val_pies[ parseInt(xvalor[0].activeIndex)];
        this.pie = valor.val_def;
    await this.util.cerrarSpinner();
  }
  async  modalrespuesta(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
                const formData = new FormData();
                formData.append('user_img',this.archivo);
              this.forma.patchValue({
                formdata:formData,
                pass_usuario : await this.hashkey.encrypt(this.forma.value.pass_usuario),
                cod_app : await this.hashkey.encrypt(environment.path_token),
                cod_empresa : await this.atrb.USUARIO_EMPRESA.usuario_empresa,
                api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionPasarela)
              });
            this.gestionUsuarios(this.forma.value);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async  avatar(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
          let cabeza = this.cabeza.split('/');
          let ojo = this.ojo.split('/');
          let boca = this.boca.split('/');
          let brazo = this.brazo.split('/');
          let pie = this.pie.split('/');
          let cabeza_ruta = cabeza[3].split("\\");
          let ojo_ruta = ojo[3].split("\\");
          let boca_ruta = boca[3].split("\\");
          let brazo_ruta = brazo[3].split("\\");
          let pie_ruta = pie[3].split("\\");
          let pie_ruta_final = pie_ruta[0]+'\\\\'+pie_ruta[1]+'\\\\'+pie_ruta[2];
          let brazo_ruta_final = brazo_ruta[0]+'\\\\'+brazo_ruta[1]+'\\\\'+brazo_ruta[2];
          let boca_ruta_final = boca_ruta[0]+'\\\\'+boca_ruta[1]+'\\\\'+boca_ruta[2];
          let ojo_ruta_final = ojo_ruta[0]+'\\\\'+ojo_ruta[1]+'\\\\'+ojo_ruta[2];
          let cabeza_ruta_final = cabeza_ruta[0]+'\\\\'+cabeza_ruta[1]+'\\\\'+cabeza_ruta[2];
              this.forma.patchValue({
                cod_usuario: await this.hashkey.encrypt(this.data.data.cod_usuario),
                val_objeto:[cabeza_ruta_final,ojo_ruta_final,boca_ruta_final,brazo_ruta_final,pie_ruta_final].join(),
                cod_app : await this.hashkey.encrypt(environment.path_token),
                cod_empresa : await this.atrb.USUARIO_EMPRESA.usuario_empresa,
                api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionPasarela)
              });
            this.gestionAvatar(this.forma.value);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async cargar_img(xvalor:any){
    try {
      await this.util.abrirSpinner();
      this.objectURL = URL.createObjectURL(xvalor.target.files[0]);
     this.archivo = xvalor.target.files[0];
     
    await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  async recuperarPass(){
    try {
      var dialogRef = this.dialog.open(FormRecuperacionComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {},
        disableClose: true,
        panelClass:'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRef.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result.proceso.toUpperCase() !== await this.atrb.CERRAR.toUpperCase()){
          await this.util.cerrarSpinner();
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      console.log(error);
    }
  }
  async gestionUsuarios(xvalor:any){
    try {
              if (xvalor.formdata.get('user_img') !== await this.atrb.UNDEFINED) {
                const img = await this.servicio.gestionarImgUserhttp(xvalor.formdata).toPromise();
                    xvalor.cod_img = img.file.path;
                    xvalor.des_img = img.file.filename;
            }else{
                    xvalor.cod_img = false;
                    xvalor.des_img = false;
            }
            xvalor.api = await this.hashkey.encrypt(await this.atrb.API_REST.ingresoUsuario);
        const response = await this.servicio.ApiResthttp(xvalor).toPromise();
        await this.util.cerrarSpinner();
        xvalor.api = await this.hashkey.encrypt(await this.atrb.API_REST.login);
       const response_ = await  this.servicio.ApiResthttp(xvalor).toPromise();
          await  this.util.agregarLocalStorage(response_);
          await this.notifi.success(response.message);
          setTimeout(() => {
            window.location.reload();
          }, 2000);
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
   }
  async gestionAvatar(xvalor:any){
    try {
            xvalor.api = await this.hashkey.encrypt(await this.atrb.API_REST.gestionValObjeto);
        const response = await this.servicio.ApiResthttp(xvalor).toPromise();
        localStorage.setItem('vtr', await this.hashkey.encrypt(response.rutas));
        await this.util.cerrarSpinner();
          await this.notifi.success(response.message);
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
   }
  async gestionPrefer(xvalor:any){
    try {
        const response = await this.servicio.ApiResthttp(xvalor).toPromise();
        await this.util.cerrarSpinner();
          localStorage.setItem('prfrncs', await this.hashkey.encrypt(xvalor.val_perfil));
          await this.notifi.success(response.message);
    } catch (error) {
      console.log(error);
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
   }
  async cambiarForma(xvalor:any){
    try {
      await this.util.abrirSpinner();
      if (parseInt(xvalor) === 2) {
        await this.util.cerrarSpinner();
       await this.listarParametroGaleriaOperacional();
       this.termino = xvalor;
       
      }else{
        await this.util.cerrarSpinner();
        this.termino = xvalor;
        if (parseInt(this.hashkey.decrypt(this.data.data.val_perfil)) === 2 ) {
          this.checked_0 = '0';
          this.checked_1 = '0';
          this.checked_2 = '0';
          this.checked_3 = '0';
          this.checked_4 = '0';
        }else{
          let check = await this.hashkey.decrypt(this.data.data.val_perfil).split(',');
          this.checked_0 = check[0] === '1' ? '1' : '0';
          this.checked_1 = check[1] === '1' ? '1' : '0';
          this.checked_2 = check[2] === '1' ? '1' : '0';
          this.checked_3 = check[3] === '1' ? '1' : '0';
          this.checked_4 = check[4] === '1' ? '1' : '0';
        }
      }
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  async cerrarmodal(){
    try {
      let accion = '';
      let dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:'',
              accion:accion},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if (result !== await this.atrb.CERRAR){
          await this.util.cerrarSpinner();
          this.dialogRef.close(result);
        }else{
          await this.util.cerrarSpinner();
       }
      });
    } catch (error) {
      console.log(error);
   }
  }
  async listarParametroGaleriaOperacional(){
    try {
        await this.util.abrirSpinner();
        await this.servicio.consultar_sesionhttp(null).toPromise();
        this.val_galeria = [];
      var valor = {
        constante_img: await this.atrb.CONSTANTES_APLICACIONES.AVATAR_PRC_GLR,
        cod_rol: await this.atrb.ROL_USUARIOS.cod_rol,
        cod_app: await this.atrb.COD_APP.cod_app,
        cod_empresa: await this.atrb.USUARIO_EMPRESA.usuario_empresa,
        api: await this.hashkey.encrypt(await this.atrb.API_REST.listarParametroAplicacionesGaleria),
      };
     const response = await  this.servicio.ApiResthttp(valor).toPromise();
              this.val_galeria = [];
              this.val_cabeza = [];
              this.val_ojo = [];
              this.val_boca = [];
              this.val_brazos = [];
              this.val_pies = [];
              this.val_galeria = [...response];
            for (const i in response) {
              response[i].val_def = environment.path_storage+response[i].val_def;
              if (parseInt(response[i].nivel_img) === 0) {
                this.val_cabeza.push(response[i]);
              }
              if (parseInt(response[i].nivel_img) === 1) {
                this.val_ojo.push(response[i]);
              }
              if (parseInt(response[i].nivel_img) === 2) {
                this.val_boca.push(response[i]);
              }
              if (parseInt(response[i].nivel_img) === 3) {
                this.val_brazos.push(response[i]);
              }
              if (parseInt(response[i].nivel_img) === 4) {
                this.val_pies.push(response[i]);
              }
            }
            if (parseInt(await this.hashkey.decrypt(localStorage.getItem('vtr'))) <= 0 ) {
              this.cabeza = this.val_cabeza[0].val_def;
              this.ojo = this.val_ojo[0].val_def;
              this.boca = this.val_boca[0].val_def;
              this.brazo = this.val_brazos[0].val_def;
              this.pie = this.val_pies[0].val_def;
            }else{
              let avatar = this.hashkey.decrypt(localStorage.getItem('vtr')).split(',');
              this.cabeza = environment.path_storage+avatar[0];
              this.ojo = environment.path_storage+avatar[1];
              this.boca = environment.path_storage+avatar[2];
              this.brazo = environment.path_storage+avatar[3];
              this.pie = environment.path_storage+avatar[4];
            }
            
        await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
  async  modalPrefer(){
    try {
      var accion2 = '';
      var dialogRefp = this.dialog.open(FormmMsgComponent, {
        width: '100vw',
        maxWidth: '100vw',
        height:'auto',
        data: {id:this.data.id_cliente,
              accion:accion2},
        disableClose: true,
        panelClass: 'pedidos_modal',
        backdropClass: "bdrop"
      });
      dialogRefp.afterClosed().subscribe(async result => {
        await this.util.abrirSpinner();
        if(result !== await this.atrb.CERRAR){
            let xvalor = {
                cod_usuario:await this.hashkey.encrypt(this.forma.value.cod_usuario),
                cod_app : await this.hashkey.encrypt(environment.path_token),
                cod_empresa : await this.atrb.USUARIO_EMPRESA.usuario_empresa,
                val_perfil:[
                  this.checked_0 === true ? '1' : '0',
                  this.checked_1 === true ? '1' : '0',
                  this.checked_2 === true ? '1' : '0',
                  this.checked_3 === true ? '1' : '0',
                  this.checked_4 === true ? '1' : '0'
                ].join(),
                api: await this.hashkey.encrypt(await this.atrb.API_REST.gestionValPerfil)
            }
            this.gestionPrefer(xvalor);
        }else{
          await this.util.cerrarSpinner();
        }
      });
    } catch (error) {
      await this.util.cerrarSpinner();
      await this.notifi.customToastNotification(error.error.message);
    }
  }
  async cambiarTema(xvalor:any){
    try {
      await this.util.abrirSpinner();
        this.checked_3 = await this.tem.toggleTheme();
        console.log(this.checked_3);
      await this.util.cerrarSpinner();
    } catch (error) {
      await this.util.cerrarSpinner();
      console.log(error);
    }
  }
}
